import { $, $$, insertHTML, remove } from 'utils/dom';
import { uniqueId } from 'utils/helper';

export default class CopyLinkToClipboard {
  constructor(props) {
    this.target = props.target;
    this.copyLink = props.copyLink;
    this.copyID = `copy-${uniqueId()}`;
  }

  createHiddenInput = e => {
    e.preventDefault();

    // to make copy to clipboard work, we have to create an hidden element with the copyLink in it
    insertHTML(
      this.target,
      'beforeend',
      `<input id="${this.copyID}" class="share__copy-url sr-only" type="text" value="${this.copyLink}">`
    );

    this.copyToClipboard();
  };

  copyToClipboard = () => {
    const copyUrl = $(`#${this.copyID}`, this.target);

    copyUrl.select(); // select url
    copyUrl.setSelectionRange(0, 99999); // For mobile devices

    /* Copy the text inside the text field */
    document.execCommand('copy');

    remove(copyUrl);

    this.showTooltip();
  };

  showTooltip = () => {
    const docLang = document.documentElement.lang;
    const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
    const text = {
      de: 'Link kopiert!',
      en: 'Copied url to clipboard!',
    };

    insertHTML(
      this.target,
      'afterend',
      `<span class="share__copy-tooltip is-small" aria-live="polite" role="status">${text[lang]}</span>`
    );

    // remove tooltip after amount of time
    setTimeout(() => {
      remove($('.share__copy-tooltip', this.target.parentElement));
    }, 1500);
  };

  bindEvents = () => {
    this.target.addEventListener('click', this.createHiddenInput);
  };

  init = () => {
    this.bindEvents();
  };
}

const copyButtons = $$('.share__copy-link');
copyButtons.length &&
  copyButtons.forEach(copyButton => {
    new CopyLinkToClipboard({
      target: copyButton,
      copyLink: window.location.href,
    }).init();
  });
